module.exports = __webpack_public_path__ + "img/box2_img11.745e0428.png";